import React, { useEffect, useRef } from 'react';
import './TeamPage.css';
import teamPic from '../../images/team-team.jpg';

const STATS = [
  { label: 'Order Fill Accuracy',   pct: 99 },
  { label: 'Client Retention Rate', pct: 91 },
  { label: 'On-Time Delivery Rate', pct: 96 },
];

export const TeamPage = () => {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const targets = sectionRef.current?.querySelectorAll<HTMLElement>('.rn-reveal');
    if (!targets) return;
    const observer = new IntersectionObserver(
      entries => entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); observer.unobserve(e.target); }
      }),
      { threshold: 0.14 }
    );
    targets.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="team" className="rn-mission" ref={sectionRef}>
      <div className="rn-mission__container">

        {/* Image column */}
        <div className="rn-mission__img-col rn-reveal">
          <div className="rn-mission__img-wrap">
            <img
              src={teamPic}
              alt="Renuit logistics team at work"
              className="rn-mission__img"
              loading="lazy"
              decoding="async"
            />
            <div className="rn-mission__badge">
              <span className="rn-mission__badge-num">12+</span>
              <span className="rn-mission__badge-label">Years in<br/>Logistics</span>
            </div>
          </div>
        </div>

        {/* Content column */}
        <div className="rn-mission__content">
          <span className="cs-topper rn-reveal">Our Mission &amp; Vision</span>
          <h2 className="cs-title rn-reveal rn-reveal-delay-1">
            Your Trusted Logistics Partner
          </h2>
          <p className="cs-text rn-reveal rn-reveal-delay-2">
            Based in St. Petersburg, FL, we serve freight and distribution clients
            throughout the Southeast U.S., Gulf Coast, and East Coast corridors.
            Fully licensed, bonded, and insured — with 12+ years of precision logistics.
          </p>

          <div className="rn-mission__bars rn-reveal rn-reveal-delay-3">
            {STATS.map(({ label, pct }) => (
              <div className="rn-mission__bar" key={label}>
                <div className="rn-mission__bar-header">
                  <span className="rn-mission__bar-label">{label}</span>
                  <span className="rn-mission__bar-pct">{pct}%</span>
                </div>
                <div className="rn-mission__bar-track">
                  <span
                    className="rn-mission__bar-fill"
                    style={{ '--pct': `${pct}%` } as React.CSSProperties}
                  />
                </div>
              </div>
            ))}
          </div>

          <a href="#services" className="cs-button-solid rn-reveal rn-reveal-delay-4">
            Explore Our Services
          </a>
        </div>

      </div>
    </section>
  );
};
